import { Button, Image } from "react-bootstrap";
import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import PublicationsService from "../../services/PublicationsService";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { app_url } from "../../services/http";
import 'datatables.net-dt'
import StatutsService from "../../services/StatutsService";
import { useSelector } from "react-redux";

export default function IndexPublications() {

    //##########################/// METHODES ##########################///
    const [publications, setPublications] = useState([])
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)

    //get liste publications
    const fetchPublications = async () => {
        await PublicationsService.index().then((res) => {
            setPublications(res.data.publications)
        })

        //initialize datatable
        $(document).ready(function () {
            setTimeout(function () {
                $('.data-table').DataTable();
            }, 1000);
        });
    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.publications_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                PublicationsService.delete(param,token).then((response) => {
                    if (response.data.erreur) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.erreur
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchPublications()
                    }

                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.erreur
                    })
                })
            }
        })
    }

    const showPdf = async (url) => {
        if (url === '') {
            Swal.fire({
                icon: 'error',
                text: "Cette publication ne contient pas de PDF !",
            });
        } else {
            try {
                const link = document.createElement('a');
                link.href = url;
                link.target = "_blank"
                link.download = `publications-${new Date().toLocaleString('fr')}.pdf`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                /*const response = await fetch(url);
                const blob = await response.blob();
                const fileUrl = URL.createObjectURL(blob);
          
                const link = document.createElement('a');
                link.href = fileUrl;
                link.download = `publications-${new Date().toLocaleString('fr')}.pdf`;
          
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
          */
                Swal.fire({
                    icon: 'success',
                    text: 'Fichier téléchargé !',
                });
            } catch (error) {
                console.log('Erreur lors du téléchargement du fichier :', error);
            }
        }
    }

    //redirection sur la page d'aperçu sans afficher les id dans l'url
    const goToShow = (param) => {
        navigate(myroutes.publications_show, { state: { id: param } })
    }

    //Rendre actif ou inactif un role
    const updateStatut = async (id, statut, table) => {
        //let form = { id, statut, table }
        await StatutsService.changeStatut(id, statut, table,token).then(response => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur
                })
            } else {
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
                fetchPublications()
            }
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchPublications();
        $("#submenu-1").addClass("show")

    }, [])


    //##########################/// END METHODES ##########################///


    return (

        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Publications </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Liste des publications <Link className="btn btn-primary btn-sm" to={myroutes.publications_create} ><i className="fa fa-plus-circle"></i></Link> </h1>
                        </div>
                        <div className="col-auto">
                            <div className="page-utilities">
                                <div className="row g-2 justify-content-start justify-content-md-end align-items-center">

                                    <div className="col-auto">
                                        <a className="btn app-btn-primary" href="#">
                                            <i className="fas fa-file-excel"></i>&nbsp;
                                            Excel
                                        </a>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-danger" href="#">
                                            <i className="fas fa-file-pdf"></i>&nbsp;
                                            Pdf
                                        </a>
                                    </div>
                                </div>{/*//row*/}
                            </div>{/*//table-utilities*/}
                        </div>{/*//col-auto*/}
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <div className="table-responsive mt-4">

                                <table className="table table-borderless table-hover app-table-hover mb-0 text-left data-table">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className=" text-white">N°</th>
                                            <th className="cell text-white">Auteur / Editeur</th>
                                            <th className="cell text-white">Titre</th>
                                            <th className="cell text-white">Type</th>
                                            <th className="cell text-white">Date</th>
                                            <th className=" text-white">Statuts</th>
                                            <th className=" text-white" scope="col">Page de garde</th>
                                            <th className=" text-white">Pdf</th>
                                            <th className=" text-white">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="" style={{ textAlign: "left" }}>
                                        {publications.length > 0 && publications.map((item, index) => (
                                            <tr key={index}>
                                                <td className="">{index + 1}</td>
                                                <td className="cell">{
                                                    (item.auteur_id === "") ?
                                                        (item.editeur_id ? item.raison_sociale : " ") :
                                                        (item.auteur_id ? item.nom_auteur : "")}
                                                </td>
                                                <td className=""><span className="truncate">{item.titre_concatene}</span></td>
                                                <td className="">{item.typepublication_id ? item.type_libelle : ""}</td>
                                                <td className=""><span>{dayjs(item.updated_at).format("DD/MM/YYYY H:m:s")} par </span>
                                                    <span className="notex">{item.updated_by ? item.nom : ''} {item.updated_by ? item.prenoms : ''}</span>
                                                </td>
                                                <td className=""><span className={(item.statut_libelle === "ACTIF") ? "badge bg-success" : "badge bg-danger"}>{item.statut_libelle}</span></td>
                                                <td className=""><Image src={app_url + "/storage/laune/" + item.laune_path} className="w-25" /></td>
                                                <td className=""><i className="fas fa-file-pdf fa-2x" onClick={() => showPdf(item.publication_path !== null ? app_url + "/storage/publications/" + item.publication_path : "")}></i></td>
                                                <td className="d-flex justify-content-center">
                                                    <Button className={item.statut_libelle === "ACTIF" ? "btn btn-sm btn-success" : "btn btn-sm btn-dark"} onClick={() => updateStatut(item.id, item.statut_libelle === "ACTIF" ? "desactivation" : "activation", "publications")} title="Changer le statut">
                                                        <i className={item.statut_libelle === "ACTIF" ? "fas fa-eye" : "fas fa-eye-slash"}></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-success" onClick={() => goToShow(item.id)} title="Détails">
                                                        <i className="fas fa-list"></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-primary" onClick={() => goToEdit(item.id)} title="Modifier">
                                                        <i className="fas fa-edit"></i></Button>
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>{/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                    {/*//End table-content*/}


                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}